import { render } from "./CreateToken.vue?vue&type=template&id=455f0cf2"
import script from "./CreateToken.vue?vue&type=script&lang=js"
export * from "./CreateToken.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__